// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"578":"3ec0b1d9","795":"a3be4f92"}[chunkId] + ".chunk.css";
};